<template>
  <div class="user-list">
    <div class="shang">
      <div class="search-bar flex">
        <div class="left">
          <el-date-picker
            v-model="dates"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="changeDate"
          >
          </el-date-picker>
          <el-button type="primary" @click="financeView">筛选</el-button>
        </div>
        <div class="right">
          <el-button @click="showSetting">对公账户设置</el-button>
          <el-button @click="exportData">导出</el-button>
        </div>
      </div>
      <el-dialog title="对公账户设置" center :visible.sync="settingbox" width="30%" :before-close="resetForm">
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
          <el-form-item label="名称" prop="company_name">
            <el-input v-model="ruleForm.company_name"></el-input>
          </el-form-item>
          <el-form-item label="开户银行" prop="company_bank">
            <el-input v-model="ruleForm.company_bank"></el-input>
          </el-form-item>
          <el-form-item label="收款账户" prop="company_no">
            <el-input v-model="ruleForm.company_no"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="resetForm('ruleForm')">取 消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
        </span>
      </el-dialog>
      <div class="data-all">
        <div class="box">
          <h3>平台收入统计</h3>
          <div>
            <div>
              <p>平台总收入</p>
              <p>{{ msg.in_total_amount || 0 }}</p>
            </div>
            <div>
              <p>课程收入</p>
              <p>{{ msg.in_lession_total_amount || 0 }}</p>
            </div>
            <div>
              <p>商品收入</p>
              <p>{{ msg.in_goods_total_amount || 0 }}</p>
            </div>
          </div>
        </div>
        <div class="box">
          <h3>平台支出统计</h3>
          <div>
            <div>
              <p>优惠券折扣</p>
              <p>{{ msg.coupon_amount || 0 }}</p>
            </div>
            <div>
              <p>缴费退款</p>
              <p>{{ msg.out_total_amount || 0 }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <h3 style="padding: 30px 0">平台流水</h3>
    <div class="search-bar flex">
      <el-select v-model="searchParam.school_uuid" placeholder="校区筛选">
        <el-option v-for="item in schoolList" :key="item.uuid" :label="item.title" :value="item.uuid"></el-option>
      </el-select>
      <el-select v-model="searchParam.trade_type" placeholder="收支类型">
        <el-option label="收入" value="1"></el-option>
        <el-option label="支出" value="2"></el-option>
      </el-select>
      <el-select v-model="searchParam.order_type" placeholder="交易类型">
        <el-option label="商品订单" value="1"></el-option>
        <el-option label="课程订单" value="2"></el-option>
        <el-option label="直播订单" value="3"></el-option>
      </el-select>
      <el-input v-model="searchParam.user_mobile" placeholder="用户手机号"></el-input>
      <el-date-picker
        v-model="dates2"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        @change="changeDate2"
      >
      </el-date-picker>
      <el-button type="primary" @click="getList">筛选</el-button>
      <el-button type="primary" @click="resetSearch">重置</el-button>
    </div>

    <div class="table">
      <el-table v-loading="loading" :data="tableData" border style="width: 100%">
        <el-table-column prop="order_sn" label="订单编号"> </el-table-column>
        <el-table-column prop="trade_mark" label="备注"> </el-table-column>
        <el-table-column prop="trade_type" label="交易类型">
          <template slot-scope="scope">
            {{ ["", "商品订单", "课程订单", "直播订单"][scope.row.order_type] }}
          </template>
        </el-table-column>
        <el-table-column prop="trade_content" label="交易内容"> </el-table-column>
        <el-table-column prop="user_name" label="用户昵称"> </el-table-column>
        <el-table-column prop="trade_amount" label="交易金额"> </el-table-column>
        <el-table-column prop="pay_type" label="交易方式">
          <template slot-scope="scope">
            {{ ["", "支付宝", "微信", "对公打款", "线下支付"][scope.row.pay_type] }}
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="时间"> </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page="page_index"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { financeList, financeView, financeExport, accountMsg, accountMsgEdit } from "@/api/analysis.js";

import { mixin } from "@/mixins/pagination.js";
import { mschool } from "../teacher-manage/mixins.js";
export default {
  components: {},
  mixins: [mixin, mschool],
  data() {
    return {
      msg: {},
      ruleForm: {},
      rules: {
        company_name: [
          {
            required: true,
            message: "请输入公司名称",
            trigger: "blur",
          },
        ],
        company_bank: [
          {
            required: true,
            message: "请输入银行名称",
            trigger: "blur",
          },
        ],
        company_no: [
          {
            required: true,
            message: "请输入银行账户",
            trigger: "blur",
          },
        ],
      },
      settingbox: false,
      dates: [],
      dates2: [],
      loading: false,
      total: 0,
      searchParam: {
        keyword_search: "",
      },
      sp: {},
      tableData: [],
    };
  },
  mounted() {
    this.getList();
    this.getSchool();
    this.financeView();
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          accountMsgEdit(this.ruleForm).then((res) => {
            if (res) {
              this.$message.success("设置成功");
              this.resetForm();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs["ruleForm"].resetFields();
      this.settingbox = false;
    },
    showSetting() {
      accountMsg().then((res) => {
        if (res) {
          this.ruleForm = res;
        }
      });
      this.settingbox = true;
    },
    hideSetting() {
      this.settingbox = false;
    },
    resetSearch() {
      this.searchParam = {};
      this.dates2 = [];
      this.getList();
    },
    resetList() {
      this.getList();
      this.financeView();
    },
    changeDate(val) {
      if (Array.isArray(val)) {
        this.sp = { start_time: val[0], end_time: val[1] };
      } else {
        this.sp = { start_time: "", end_time: "" };

        this.financeView();
      }
      console.log(val);
    },
    changeDate2(val) {
      if (Array.isArray(val)) {
        this.searchParam = {
          ...this.searchParam,
          start_time: val[0],
          end_time: val[1],
        };
      } else {
        this.searchParam = {
          ...this.searchParam,
          start_time: "",
          end_time: "",
        };

        this.getList();
      }
    },
    financeView() {
      financeView({
        start_time: this.sp.start_time,
        end_time: this.sp.end_time,
      }).then((res) => {
        if (res) {
          this.msg = res;
        }
      });
    },
    exportData() {
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
      };
      financeExport(param);
    },

    addStudent() {
      this.$router.push({ path: "/teacher-add" });
    },
    toSchedule(row) {
      this.$router.push({ path: "/teacher-schedule", query: row });
    },
    toDetail(row) {
      console.log(row);
      this.$router.push({ path: "/teacher-add", query: row });
    },
    async getList() {
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
      };
      console.log(param);
      this.loading = true;
      const res = await financeList(param);
      this.loading = false;
      if (res.data instanceof Array) {
        this.total = res.total;
        this.tableData = res.data;
      }
      console.log(res);
    },
    deleteItem(row) {
      console.log(row);
      this.$confirm("确定要删除该老师吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteTeacher(row.uuid).then((res) => {
            console.log(res);
            if (res) {
              this.$message.success("成功");
              this.getList();
            }
          });
          // this.userOption()
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>

<style scoped="scoped" lang="less">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
.data-all {
  display: flex;
  .box {
    box-shadow: 0 2px 15px #bbb;
    padding: 20px;
    margin: 20px 0;
    margin-right: 20px;
    & > div {
      display: flex;
      text-align: center;
      justify-content: space-between;
      width: 250px;
      margin-top: 20px;
    }
  }
}
</style>
